import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

interface SeniorityData {
    level: string;
    count: number;
    percentage: number;
}

const seniorityData: SeniorityData[] = [
    { level: 'Estagiário', count: 18, percentage: 8.5 },
    { level: 'Júnior', count: 67, percentage: 31.5 },
    { level: 'Pleno', count: 78, percentage: 36.6 },
    { level: 'Sênior', count: 43, percentage: 20.2 },
    { level: 'Especialista', count: 7, percentage: 3.3 },
];

const COLORS = ['#F59E0B', '#3B82F6', '#10B981', '#8B5CF6', '#EF4444'];

const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
            <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
                <p className="font-medium text-gray-900">{data.level}</p>
                <p className="text-sm text-gray-600">
                    {data.count} colaboradores ({data.percentage}%)
                </p>
            </div>
        );
    }
    return null;
};

export default function SeniorityDistribution() {
    const totalCollaborators = seniorityData.reduce((sum, item) => sum + item.count, 0);

    return (
        <div className="bg-white rounded-lg shadow p-4">
            {/* Header */}
            <div className="mb-4">
                <h3 className="text-base font-semibold text-gray-900 mb-1">
                    Senioridade
                </h3>
                <p className="text-xs text-gray-600">
                    Distribuição por nível de {totalCollaborators} colaboradores
                </p>
            </div>

            {/* Chart */}
            <div className="h-48">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={seniorityData}
                            cx="50%"
                            cy="50%"
                            outerRadius={70}
                            fill="#8884d8"
                            dataKey="count"
                            stroke="#ffffff"
                            strokeWidth={2}
                        >
                            {seniorityData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} />
                    </PieChart>
                </ResponsiveContainer>
            </div>

            {/* Stats Summary */}
            <div className="mt-4 grid grid-cols-2 md:grid-cols-5 gap-3 pt-3 border-t border-gray-200">
                {seniorityData.map((item, index) => (
                    <div key={item.level} className="text-center">
                        <div className="flex items-center justify-center mb-1">
                            <div
                                className="w-2 h-2 rounded-full mr-1"
                                style={{ backgroundColor: COLORS[index] }}
                            />
                            <span className="text-xs font-medium text-gray-700">{item.level}</span>
                        </div>
                        <div className="text-lg font-bold text-gray-900">{item.count}</div>
                        <div className="text-xs text-gray-500">{item.percentage}%</div>
                    </div>
                ))}
            </div>
        </div>
    );
} 